import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import get from 'lodash/get.js';

import { BarHeader } from 'dibs-elements/exports/BarHeader.tsx';
import { ContemporaryLandingStyleRow } from './ContemporaryLandingStyleRow.jsx';

const ContemporaryLandingStyleModuleComponent = ({ contemporaryLandingRow, showCta = false }) => {
    if (!contemporaryLandingRow || !contemporaryLandingRow.items) {
        return null;
    }
    const styleRows = contemporaryLandingRow.items.filter(item => item.type === 'styleRow');

    return (
        <Fragment>
            <BarHeader title={get(contemporaryLandingRow, 'items[0].text')} />
            {styleRows.map((styleRow, index) => (
                <ContemporaryLandingStyleRow
                    key={`${styleRow.title}-${index}`}
                    items={get(styleRow, 'items')}
                    rowIndex={index}
                    showCta={showCta}
                />
            ))}
        </Fragment>
    );
};

ContemporaryLandingStyleModuleComponent.propTypes = {
    showCta: PropTypes.bool.isRequired,
    contemporaryLandingRow: PropTypes.object,
};

export const ContemporaryLandingStyleModule = createFragmentContainer(
    ContemporaryLandingStyleModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingStyleModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingHeader {
                            text
                            type
                        }
                        ... on ContemporaryLandingRow {
                            items {
                                ... on ContemporaryLandingStyleRowItem {
                                    description
                                    imagePath
                                    title
                                    linkData {
                                        #SeoLink is used in ContemporaryLandingStyleRowItem
                                        ...SeoLink_linkData
                                    }
                                }
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
